import { Typography } from "@mui/material";
import React from "react";
import { AppointmentOverviewContext } from "../context/appointmentOverviewContext";
import SearchControllsProps from "../interface/searchControllsProps";

const LoadingMessage = (): React.JSX.Element => {
  const {
    searchControlls,
  }: {
    searchControlls: SearchControllsProps;
  } = React.useContext(AppointmentOverviewContext);

  return (
    <React.Fragment>
      {searchControlls.loading && (
        <Typography
          variant="body1"
          color="initial"
          sx={{ textAlign: "center", mt: 2 }}
        >
          Termine werden geladen...
        </Typography>
      )}
    </React.Fragment>
  );
};

export default LoadingMessage;
